<template>
  <div class="container-fluid">
    <div class="row mb-4">
      <div
        class="col-md-12 cities-bg d-flex flex-column justify-content-center align-items-center text-center"
      >
        <div class="gradient text-head font-weight-bold" data-aos="zoom-in">
          A Mobile App for your Church
        </div>
        <div class="s-24 fw-500 text-dark" data-aos="zoom-in">
          Connect with your members & church community <br />
          any time any day on their smartphone.
        </div>
        <div data-aos="zoom-in" class="s-24 fw-500 text-dark mt-4">
          GET ONE TODAY!
        </div>
        <div class="d-flex justify-content-center mt-4">
          <div data-aos="fade-right" class="mx-2">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.faithconnect"
              class="text-decoration-none"
            >
              <img
                class="img-fluid app-store-badge"
                src="../../../assets/mobileonboarding/google-play.png"
                alt="Google Play"
              />
            </a>
          </div>
          <div data-aos="fade-left" class="mx-2">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.faithconnect"
              class="text-decoration-none"
            >
              <img
                class="img-fluid app-store-badge"
                src="../../../assets/mobileonboarding/app-store.png"
                alt="App Store"
              />
            </a>
          </div>
        </div>
        <div
          data-aos="zoom-in"
          class="col-md-12 mobilephonebg d-flex justify-content-center"
        >
          <img
            class="img-fluid"
            src="../../../assets/mobileonboarding/mobilephone2.png"
            style="height: 900.05px; width: 824.73px"
            alt="Mobile Phone Mockup"
          />
        </div>
      </div>

      <div class="col-md-12 gradientbg"></div>
      <div class="carousel-container">
        <div class="feature-scroll-wrapper d-flex" ref="scrollWrapper">
          <!-- First set of images -->
          <div
            class="feature-item mr-3"
            v-for="(feature, index) in features"
            :key="`first-${index}`"
          >
            <img :src="feature.image" class="img-fluid rounded" alt="Feature" />
          </div>

          <!-- Duplicate set for seamless loop -->
          <div
            class="feature-item mr-3"
            v-for="(feature, index) in features"
            :key="`second-${index}`"
          >
            <img :src="feature.image" class="img-fluid rounded" alt="Feature" />
          </div>
        </div>
      </div>
      <div
        class="col-md-12 text-center s-24 text-dak fw-400"
        style="margin-top: 9rem"
      >
        FAITH CONNECT MOBILE APP
      </div>
      <div
        data-aos="zoom-in"
        class="col-md-12 text-center font-weight-600 s-32"
        style="color: #031169"
      >
        Church Mobile App that brings <br />
        Members closer to The Pulpit <br />
        <span class="font-weight-bold">Like never before</span>
      </div>
      <div class="col-md-12 d-flex justify-content-center mt-5">
        <div class="col-md-3 col-3 d-flex">
          <div data-aos="fade-right">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.faithconnect"
              class="w-100 text-decoration-none"
            >
              <img
                class="w-100"
                src="../../../assets/mobileonboarding/google-play.png"
                alt=""
              />
            </a>
          </div>
          <div data-aos="fade-left">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.faithconnect"
              class="w-100 text-decoration-none"
            >
              <img
                class="w-100"
                src="../../../assets/mobileonboarding/app-store.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-center mt-5">
        <div class="col-md-11 mb-5 mt-2 position-relative">
          <div
            data-aos="fade-up"
            class="embed-responsive embed-responsive-16by9 border-radius-20 custom-video-height position-relative"
          >
            <!-- Thumbnail (shown initially) -->
            <div
              v-if="!showVideo"
              class="w-100 h-100 embed-responsive-item"
              style="z-index: 2"
              @click="startVideo"
            >
              <img
                :src="require('@/assets/mobileonboarding/tumbnail1.png')"
                alt="Video Thumbnail"
                class="w-100 thumbnail h-100"
              />
            </div>

            <!-- Video (shown after click) -->
            <iframe
              sandbox="allow-downloads allow-scripts allow-same-origin"
              v-if="showVideo"
              class="embed-responsive-item"
              width="100%"
              height="315"
              :src="youtubeUrl"
              title="ChurchPlus Intro"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>

            <!-- Play Button (shown over thumbnail) -->
            <el-button
              v-if="!showVideo"
              color="#FF0202"
              size="large"
              round
              @click="startVideo"
              style="
                padding: 2.5rem 1rem !important;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 3;
              "
              class="d-flex justify-content-center align-items-center video-overlay-button py-4"
            >
              <span class="mb-4 mt-3 mr-2">
                <PlayCircleIcon class="w-20 h-20" />
              </span>
              <span>See how it works</span>
            </el-button>
          </div>
        </div>
        <!-- <div class="col-md-11 mb-5 mt-2 position-relative">
          <div
            data-aos="fade-up"
            class="embed-responsive embed-responsive-16by9 border-radius-20 custom-video-height"
          >
            <iframe
              class="embed-responsive-item"
              width="100%"
              height="315"
              :src="youtubeUrl"
              title="ChurchPlus Intro"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>

          <el-button
            color="#FF0202"
            size="large"
            round
            @click="showVideoModal"
            style="padding: 2.5rem 1rem !important"
            class="d-flex justify-content-center align-items-center video-overlay-button py-4"
          >
            <span class="mb-4 mt-3 mr-2"
              ><PlayCircleIcon class="w-20 h-20"
            /></span>
            <span>See how it works</span>
          </el-button>
        </div> -->
      </div>
      <div class="col-md-12 my-5 d-flex justify-content-center">
        <div class="col-md-3 col-11">
          <router-link
            :to="{ name: 'OnboardingProcess' }"
            class="d-flex justify-content-center w-100 text-decoration-none"
          >
            <el-button
              class="text-white py-4 w-100"
              :color="primarycolor"
              size="large"
              round
              >Start Mobile App Setup</el-button
            >
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref, onMounted, onUnmounted, computed } from "vue";
import PlayCircleIcon from "../../../components/icons/PlayCircleIcon.vue";
// import thumbnailImage from "@/assets/mobileonboarding/fconnect.png";
const primarycolor = inject("primarycolor");

const showVideo = ref(false);
// const thumbnailImage = new URL('@/assets/mobileonboarding/fconnect.png', import.meta.url).href;
const youtubeUrl = ref(
  "https://www.youtube.com/embed/268s0A-21X4?si=1S-m6W_EeEovjw5F?autoplay=1&mute=1"
);

// Simple method to start video
const startVideo = () => {
  showVideo.value = true;
};

// Your existing method (can call startVideo or open modal)
const showVideoModal = () => {
  startVideo(); // or your existing modal logic
};
const isVideoPlaying = ref(false);

const startAnimation = () => {
  if (scrollWrapper.value) {
    scrollWrapper.value.style.animationPlayState = "running";
  }
};

const pauseAnimation = () => {
  if (scrollWrapper.value) {
    scrollWrapper.value.style.animationPlayState = "paused";
  }
};

const resumeAnimation = () => {
  if (scrollWrapper.value) {
    scrollWrapper.value.style.animationPlayState = "running";
  }
};

// Optional: Handle window focus/blur
const handleWindowBlur = () => pauseAnimation();
const handleWindowFocus = () => resumeAnimation();

onMounted(() => {
  startAnimation();

  // Optional: Pause on window blur, resume on focus
  window.addEventListener("blur", handleWindowBlur);
  window.addEventListener("focus", handleWindowFocus);
});

onUnmounted(() => {
  // Clean up event listeners
  window.removeEventListener("blur", handleWindowBlur);
  window.removeEventListener("focus", handleWindowFocus);
});

// Expose methods for parent component if needed
defineExpose({
  startAnimation,
  pauseAnimation,
  resumeAnimation,
});
const scrollWrapper = ref(null);

const features = [
  {
    image: require("../../../assets/mobileonboarding/fconnect.png"),
  },
  {
    image: require("../../../assets//mobileonboarding/fconnect5.png"),
  },
  {
    image: require("../../../assets/mobileonboarding/fconnect2.png"),
  },
  {
    image: require("../../../assets/mobileonboarding/fconnect3.png"),
  },
  {
    image: require("@/assets/mobileonboarding/fconnect4.jpg"),
  },
];
</script>

<style scoped>
.thumbnail {
  width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 12px;
}
.carousel-container {
  overflow: hidden;
  border-radius: 0.375rem; /* Bootstrap 4 rounded */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); /* Bootstrap 4 shadow */
  background-color: #fff;
  padding: 1.25rem; /* Bootstrap 4 p-3 equivalent */
  margin-bottom: 1.5rem;
}

.feature-scroll-wrapper {
  animation: scroll 25s linear infinite;
  width: calc(320px * 10); /* Adjust based on your image width and count */
  will-change: transform; /* Optimize for animations */
}

.feature-item {
  flex: 0 0 300px; /* Fixed width for each item */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-0.25rem); /* Bootstrap 4 spacing */
  box-shadow: 0 0.75rem 2rem rgba(0, 0, 0, 0.15);
}

.feature-item img {
  width: 100%;
  height: auto;
  border-radius: 0.375rem; /* Bootstrap 4 rounded */
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); /* Bootstrap 4 shadow-sm */
  transition: all 0.3s ease;
  background-color: #f8f9fa; /* Bootstrap 4 bg-light */
}

.feature-item img:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); /* Bootstrap 4 shadow */
}

@keyframes scroll {
  0% {
    transform: translateX(-50%); /* Start from the duplicate set position */
  }
  100% {
    transform: translateX(0); /* Move to show original set */
  }
}

/* Pause animation on hover */
.carousel-container:hover .feature-scroll-wrapper {
  animation-play-state: paused;
}

/* Bootstrap 4 responsive breakpoints */
@media (max-width: 991.98px) {
  /* Bootstrap 4 lg breakpoint */
  .feature-item {
    flex: 0 0 280px;
  }

  .feature-scroll-wrapper {
    animation-duration: 20s;
    width: calc(300px * 10);
  }
}

@media (max-width: 767.98px) {
  /* Bootstrap 4 md breakpoint */
  .feature-item {
    flex: 0 0 250px;
  }

  .feature-scroll-wrapper {
    animation-duration: 18s;
    width: calc(270px * 10);
  }

  .carousel-container {
    padding: 1rem; /* Bootstrap 4 p-2 equivalent */
  }
}

@media (max-width: 575.98px) {
  /* Bootstrap 4 sm breakpoint */
  .feature-item {
    flex: 0 0 200px;
  }

  .feature-scroll-wrapper {
    animation-duration: 15s;
    width: calc(220px * 10);
  }

  .carousel-container {
    padding: 0.75rem; /* Smaller padding for mobile */
  }
}

/* Performance optimizations */
.feature-scroll-wrapper {
  backface-visibility: hidden;
  perspective: 1000px;
}

.feature-item {
  backface-visibility: hidden;
}

/* Smooth scrolling for better performance */
@media (prefers-reduced-motion: reduce) {
  .feature-scroll-wrapper {
    animation: none;
  }

  .feature-item {
    transition: none;
  }
}

.feature-scroll-wrapper {
  overflow-x: auto;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 1rem;
}

.feature-item {
  min-width: 250px;
  max-width: 250px;
  scroll-snap-align: start;
  background: white;
  border-radius: 15px;
  flex: none;
}

.cities-bg {
  background-image: url("../../../assets/mobileonboarding/cityimage.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  top: 0;
  height: 801px; /* Removed !important, try to rely on cascade or other Bootstrap classes first */
  position: relative; /* Needed for z-index if overlapping */
  z-index: 1; /* Ensure it's above other elements if needed */
}

.mobilephonebg {
  z-index: 1999; /* Removed !important, try to rely on cascade */
  position: absolute;
  top: 40rem; /* This value might need adjustment for responsiveness */
}

.gradientbg {
  background: linear-gradient(180deg, #b8deff 0%, #ffffff 100%);
  height: 1099.77px; /* Removed !important */
  position: relative;
  top: -14rem; /* This value might need adjustment for responsiveness */
  z-index: -1; /* Placed behind other elements */
}

.gradient {
  background: linear-gradient(90deg, #f36850 0%, #c0279c 49.01%, #2e115b 100%);
  color: rgba(255, 255, 255, 0.1);
  white-space: nowrap;
  background-clip: text;
  -webkit-background-clip: text; /* For webkit browsers */
  -webkit-text-fill-color: transparent; /* For webkit browsers */
  font-size: 64px; /* Removed !important, consider responsive font sizes */
}
.pay-now-img {
  background-image: url("../../../assets/mobileonboarding/pay-now.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 102px !important;
}

/* Added a class for app store badges for consistent sizing */
.app-store-badge {
  max-width: 150px; /* Adjust as needed */
  height: auto;
}
.video-overlay-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
  z-index: 10;
}

/* Responsive font sizes (example using Bootstrap's responsive utilities or media queries) */
@media (max-width: 768px) {
  .gradient {
    font-size: 40px; /* Smaller font for smaller screens */
    white-space: normal; /* Allow wrapping on smaller screens */
  }
}
</style>

<!-- <template>
  <div class="bg-image d-none d-sm-block" data-aos="zoom-in"></div>
  <div class="row justify-content-center mt-4">
    <div class="col-md-12 text-center s-26 text-dak fw-400">
      FAITH CONNECT MOBILE APP
    </div>
    <div
      data-aos="zoom-in"
      class="col-md-12 text-center font-weight-600 s-32"
      style="color: #031169"
    >
      Church Mobile App that brings <br />
      Members closer to The Pulpit <br />
      <span class="font-weight-bold">Like never before</span>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-4">
      <div class="col-md-3 col-3 d-flex">
        <div data-aos="fade-right">
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.faithconnect"
            class="w-100 text-decoration-none"
          >
            <img
              class="w-100"
              src="../../../assets/mobileonboarding/google-play.png"
              alt=""
            />
          </a>
        </div>
        <div data-aos="fade-left">
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.faithconnect"
            class="w-100 text-decoration-none"
          >
            <img
              class="w-100"
              src="../../../assets/mobileonboarding/app-store.png"
              alt=""
            />
          </a>
        </div>
      </div>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-5">
      <div class="col-md-11 mb-5 mt-2 position-relative">
        
        <div
         data-aos="fade-up"
          class="embed-responsive embed-responsive-16by9 border-radius-20 custom-video-height"
        >
          <iframe
            class="embed-responsive-item"
            width="100%"
            height="315"
            :src="youtubeUrl"
            title="ChurchPlus Intro"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>

        <el-button
          color="#FF0202"
          size="large"
          round
          @click="showVideoModal"
          style="padding: 2.5rem 1rem !important"
          class="d-flex justify-content-center align-items-center video-overlay-button py-4"
        >
          <span class="mb-4 mt-3 mr-2"
            ><PlayCircleIcon class="w-20 h-20"
          /></span>
          <span>See how it works</span>
        </el-button>
      </div>
    </div>

    <div class="col-md-12 col-12 mt-4 d-flex justify-content-center">
      <div class="col-md-11 steps">
        <div class="row justify-content-center mb-5">
          <div class="col-md-10 col-11 py-5">
            <div class="row mt-3">
              <div
                class="col-md-12 text-center gradient h2 font-weight-bold the-game text-head"
              >
                Steps to Set Up Mobile App for your Church
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 bg-white p-4 mt-3">
                <div class="row justify-content-end mt-3">
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-6 col-md-4 px-0">
                        <div
                          class="mt-2 px-0 d-flex align-items-center cursor-pointer"
                        >
                          <div class="text-font active-tab">1</div>
                          <hr class="hr w-100" />
                        </div>
                      </div>
                      <div class="col-6 col-md-4 px-0">
                        <div
                          class="mt-2 px-0 d-flex align-items-center cursor-pointer"
                        >
                          <div class="text-font active-tab">2</div>
                          <hr class="hr w-100" />
                        </div>
                      </div>
                      <div class="col-6 col-md-4 px-0">
                        <div
                          class="mt-2 px-0 d-flex align-items-center cursor-pointer"
                        >
                          <div class="text-font active-tab">3</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center text-center">
                  <div class="col-md-12 col-10 mt-4">
                    <div class="row">
                      <div data-aos="fade-right" class="col-12 col-sm-6 col-md-4 mt-4 mt-md-0">
                        <div
                          class="text-head col-md-12 s-24 text-dak font-weight-bold"
                        >
                          Onboard and fill <br />
                          your details
                        </div>
                        <div class="text-head col-md-12 fw-400 s-17 text-dak">
                          We request for Basic info to get you started Quickly
                        </div>
                        <div
                          class="mt-2 onboard-img col-md-12"
                          style="border-radius: 10px"
                        ></div>
                      </div>
                      <div
                        class="col-12 col-sm-6 col-md-4 mt-5 mt-sm-4 mt-md-0"
                      >
                        <div
                          class="text-head col-md-12 s-24 text-dak font-weight-bold"
                        >
                          Pay and Share the App <br />
                          with your Members
                        </div>
                        <div class="text-head col-md-12 fw-400 s-17 text-dak">
                          A share link will be provided for you to share to all
                          members
                        </div>
                        <div
                          class="mt-2 col-md-12 pay-now-img"
                          style="border-radius: 10px"
                        ></div>
                      </div>
                      <div  data-aos="fade-left" class="col-12 col-sm-6 col-md-4 mt-5 mt-md-0">
                        <div
                          class="text-head col-md-12 font-weight-bold s-24 text-dak"
                        >
                          It’s Done! Start <br />
                          Posting
                        </div>
                        <div class="text-head col-md-12 fw-400 s-17 text-dak">
                          Create the First Post on your Application.
                        </div>
                        <div
                          class="mt-2 col-md-12 done-post-img"
                          style="border-radius: 10px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
          data-aos="fade-up"
            class="col-md-12 text-center fw-400 mt-4 s-32"
            style="color: #113269"
          >
            “It’s not just a Church App, It’s <br />
            <span class="font-weight-bold"
              >everything every Church need to <br />
              engage & Connect to Members 24/7.”</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-5 mb-4 d-flex justify-content-center">
      <div class="col-md-3 col-11">
        <router-link
          :to="{ name: 'OnboardingProcess' }"
          class="d-flex justify-content-center w-100 text-decoration-none"
        >
          <el-button
            class="text-white py-4 w-100"
            :color="primarycolor"
            size="large"
            round
            >Start Mobile App Setup</el-button
          >
        </router-link>
      </div>
    </div>
  </div>
</template>
<script setup>
import { inject, ref } from "vue";
import PlayCircleIcon from "../../../components/icons/PlayCircleIcon.vue";
const primarycolor = inject("primarycolor");
const showVideo = ref(false);
const youtubeUrl = ref(
  "https://www.youtube.com/embed/268s0A-21X4?si=1S-m6W_EeEovjw5F?autoplay=1&mute=1"
);
const showVideoModal = () => {
  showVideo.value = true;
};
</script>

<style scoped>
.video-overlay-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
  z-index: 10;
}
.bg-image {
  background-image: url(../../../assets/mobileonboarding/heroImage.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transition: all 0.7s ease-in-out;
  height: 100vh;
  width: 100%;
}
.done-post-img {
  background-image: url("../../../assets/mobileonboarding/done-posting.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 102px !important;
  /* border-radius: 10px; */
}

.onboard-img {
  background-image: url("../../../assets/mobileonboarding/onboard.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 102px !important;
}
.pay-now-img {
  background-image: url("../../../assets/mobileonboarding/pay-now.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 102px !important;
}
.gradient {
  background: linear-gradient(90deg, #f36850 0%, #c0279c 49.01%, #2e115b 100%);
  color: rgba(255, 255, 255, 0.1);
  white-space: nowrap;
  background-clip: text;
  font-size: 40px !important;
}
.active-tab {
  background: #595959;
  padding: 0.6rem 2rem 1rem 1.3rem;
  color: #eee;
  font-weight: 600;
  white-space: initial;
  font-size: 1rem;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  outline: transparent !important;
}
.steps {
  border-radius: 15px !important;
  background: rgba(241, 241, 241, 0.3) !important;
}
</style> -->
